import React, { useEffect, useState, useMemo } from "react";
import {
  Row,
  Col,
  Button,
  Modal,
  Tag,
  Table,
  Input,
  DatePicker,
  InputNumber,
  Select,
  message,
  Space,
  Tooltip,
  Upload,
  Radio,
} from "antd";
import {
  EditOutlined,
  CheckSquareOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import {
  addHistoriqueTrajet,
  addTrajet,
  addCamionToTrajet,
  removeCamionFromTrajet,
  get_ListeTrajet,
  updateTrajet,
} from "../../../api/trajet";
import { get_listeCamion } from "../../../api/camion";
import formatDateFr from "../../../utils/utils";
import moment from "moment";
import "moment/locale/fr";
import { getall_facture } from "../../../api/factures";
import { get_ListeClients } from "../../../api/clients";
import { get_ListeRegion } from "../../../api/region";

moment.locale("fr");

const { TextArea } = Input;
const { Option } = Select;

const Trajet = () => {
  const [listeFactures, setlisteFactures] = useState([]);
  const [loading, setloading] = useState(false);
  const [showAddModal, setshowAddModal] = useState(false);
  const [currentTrajet, setcurrentTrajet] = useState({
    id: null,
    date_depart: null,
    date_arrive: null,
    description: null,
    facture_id: null,
    camion_ids: [],
    pieces_jointes: [],
    kilometrage: 0,
    carburant: 0,
    fond_de_cuve: 0,
    approvisionnement: 0,
    statut: true,
  });
  const [camionsOrigine, setcamionsOrigine] = useState([]);
  const [listeCamion, setlisteCamion] = useState([]);
  const [listeTrajet, setlisteTrajet] = useState([]);
  const [isUpdate, setIsUpdate] = useState(false);
  const historiqueInitial = {
    camion_id: null,
    trajet_id: null,
    date_arrive: null,
    kilometrage: 0,
    fond_de_cuve: 0,
    description: null,
    pieces_jointes: [],
  };
  const [listeClient, setListeClients] = useState([]);
  const [listeRegion, setlisteRegion] = useState([]);

  const [historiqueTrajet, sethistoriqueTrajet] = useState(historiqueInitial);
  const [modalHistorique, setmodalHistorique] = useState(false);
  const columnsTablePiece = [
    {
      title: "Id",
      dataIndex: "id",
      key: "id",
      align: "center",
      width: 50,
    },
    // {
    //   title: "Date",
    //   dataIndex: "date_depart",
    //   key: "date_depart",
    //   align: "center",
    //   render: (date) => formatDateFr(date),
    //   width: 150,

    // },
    {
      title: "Date",
      dataIndex: "date_depart",
      key: "date_depart",
      align: "center",
      render: (text) =>
        new Date(text).toISOString().slice(0, 19).replace("T", " "),
    },
    {
      title: "Camions",
      dataIndex: "camions",
      key: "camions",
      align: "center",
      filters: listeCamion.map((c) => ({ text: c.imm, value: c.id })),
      onFilter: (value, record) =>
        (record.camions || []).some((c) => c.id === value),
      render: (camions) =>
        (camions || []).map((c) => (
          <div>
            <Tag color="cyan" key={c.id}>
              {c.imm}
            </Tag><br />
            <span>{c.chauffeur_nom} ({c.chauffeur_contact})</span>
          </div>
        )),
    },
   {
  title: "Client",
  dataIndex: "client_nom",
  key: "client_nom",
  align: "center",
  filters: Array.from(
    new Set(listeClient.map((item) => item.nom))
  ).map((name) => ({
    text: name,
    value: name,
  })),
  onFilter: (value, record) => record.client_nom === value,

  render: (clientNom, record) => (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 4,
      }}
    >
      <span
        style={{
          fontWeight: 500,
          maxWidth: 180,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
        title={clientNom}
      >
        {clientNom}
      </span>

      {record.facture_ref && (
        <Tag
          color="geekblue"
          style={{
            maxWidth: 120,
            margin: 0,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            display: "inline-block",
          }}
          title={record.facture_ref}
        >
          {record.facture_ref}
        </Tag>
      )}
    </div>
  ),
},
    {
      title: "Départ",
      dataIndex: "region_depart",
      key: "region_depart",
      filters: listeRegion.map((r) => ({
        text: r.nom,
        value: r.id,
      })),
      align: "center",
      onFilter: (value, record) => record.region_depart === value,
      render: (rd) => {
        const reg = listeRegion.find((u) => u.id === rd);
        return <Tag color="gold">{reg ? reg.nom : "Inconnu"}</Tag>;
      },
    },
    {
      title: "Destination",
      dataIndex: "region_arrive",
      key: "region_arrive",
      filters: listeRegion.map((r) => ({
        text: r.nom,
        value: r.id,
      })),
      onFilter: (value, record) => record.region_arrive === value,
      render: (rd) => {
        const reg = listeRegion.find((u) => u.id === rd);
        return <Tag color="green">{reg ? reg.nom : "Inconnu"}</Tag>;
      },
    },
    {
      title: "Distance",
      dataIndex: "distance",
      key: "distance",
      align: "center",
    },
    {
      title: "Poids",
      dataIndex: "poids",
      key: "poids",
      align: "center",
    },
  ];

  if (parseInt(localStorage.getItem("fonction_id")) === 1) {
    columnsTablePiece.push({
      title: "Actions",
      key: "actions",
      align: "center",
      render: (_, record) => (
        <Space size="middle">
          <Tooltip title="Editer">
            <Button
              type="default"
              icon={<EditOutlined />}
              style={{
                backgroundColor: "#ffc107",
                color: "white",
                borderColor: "#ffc107",
              }}
              onClick={() => {
                const camionIds = (record.camions || []).map((c) => c.id);

                setcurrentTrajet({
                  id: record.id,
                  date_depart: record.date_depart
                    ? moment(record.date_depart)
                    : null,
                  date_arrive: record.date_arrive
                    ? moment(record.date_arrive)
                    : null,
                  description: record.description,
                  facture_id: record.facture_id,
                  camion_ids: camionIds,
                  pieces_jointes: (record.pj || []).map((chemin, index) => ({
                    uid: `existing-${index}`,
                    name: chemin.split("/").pop(),
                    status: "done",
                    url: chemin,
                  })),
                  kilometrage: record.kilometrage || 0,
                  carburant: record.carburant || 0,
                  fond_de_cuve: record.fond_de_cuve || 0,
                  approvisionnement: record.approvisionnement || 0,
                });
                setcamionsOrigine(camionIds);
                setIsUpdate(true);
                setshowAddModal(true);
              }}
            />
          </Tooltip>
          <Tooltip title="Mettre à jour">
            <Button
              type="default"
              icon={<CheckSquareOutlined />}
              style={{
                backgroundColor: "#229807ff",
                color: "white",
                borderColor: "#229807ff",
              }}
              onClick={() => {
                const camions = record.camions || [];
                sethistoriqueTrajet({
                  ...historiqueInitial,
                  camion_id: camions.length === 1 ? camions[0].id : null,
                  trajet_id: record.id,
                });
                setmodalHistorique(true);
              }}
            />
          </Tooltip>
        </Space>
      ),
    });
  }

  const fetchListeClients = async () => {
    const res = await get_ListeClients();
    setListeClients(res.data);
  };

  const fetchRegions = async () => {
    const res = await get_ListeRegion();
    setlisteRegion(res.data || []);
  };

  useEffect(() => {
    fetchListeClients(),
      fetchRegions();
    fetchListeCamion();
    fetchFacture();
    fetchListeTrajet();
  }, []);

  const nombreJours = useMemo(() => {
    if (!currentTrajet.date_depart || !currentTrajet.date_arrive) return 0;
    const diffMs =
      new Date(currentTrajet.date_arrive) - new Date(currentTrajet.date_depart);
    const diffJours = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
    return diffJours > 0 ? diffJours : 0;
  }, [currentTrajet.date_depart, currentTrajet.date_arrive]);

  const totalCarburantAvantDepart = useMemo(() => {
    const fondDeCuve = Number(currentTrajet.fond_de_cuve) || 0;
    const approvisionnement = Number(currentTrajet.approvisionnement) || 0;
    return fondDeCuve + approvisionnement;
  }, [currentTrajet.fond_de_cuve, currentTrajet.approvisionnement]);

  const handleReload = () => {
    setloading(true);
    setTimeout(() => {
      window.location.reload();
    }, 2000);
  };

  const fetchListeCamion = async () => {
    const res = await get_listeCamion();
    if (res.status === "success") {
      setlisteCamion(res.data);
    }
  };

  const fetchFacture = async (range = []) => {
    try {
      let start, end;
      if (range.length === 2) {
        start = moment(range[0]).format("YYYY-MM-DD HH:mm:ss");
        end = moment(range[1]).format("YYYY-MM-DD HH:mm:ss");
      } else {
        end = moment().format("YYYY-MM-DD HH:mm:ss");
        start = moment().subtract(3, "months").format("YYYY-MM-DD HH:mm:ss");
      }
      const res = await getall_facture({ start, end });
      if (res.data && Array.isArray(res.data)) {
        setlisteFactures(res.data);
      } else {
        message.warning("Aucune donnée trouvée.");
      }
    } catch (error) {
      message.error("Erreur lors du chargement des factures");
    }
  };

  const fetchListeTrajet = async () => {
    const res = await get_ListeTrajet();
    console.log("fetchListeTrajet res:", res.data);
    if (res.status === "success") {
      setlisteTrajet(res.data);
    }
  };

  const handleAddTrajet = async () => {
    if (!currentTrajet.facture_id) {
      message.warning("Veuillez sélectionner une facture");
      return;
    }
    if (!currentTrajet.date_depart) {
      message.warning("La date de départ est obligatoire");
      return;
    }

    try {
      setloading(true);
      const payload = {
        ...currentTrajet,
        date_depart: currentTrajet.date_depart
          ? currentTrajet.date_depart.format("YYYY-MM-DD HH:mm:ss")
          : null,
        date_arrive: currentTrajet.date_arrive
          ? currentTrajet.date_arrive.format("YYYY-MM-DD HH:mm:ss")
          : null,
        nb_jours: nombreJours,
        total_carburant_avant_depart: totalCarburantAvantDepart,
      };
      let res = null;

      if (isUpdate) {
        res = await updateTrajet(payload);

        const camionsActuels = currentTrajet.camion_ids || [];
        const aAjouter = camionsActuels.filter(
          (id) => !camionsOrigine.includes(id),
        );
        const aRetirer = camionsOrigine.filter(
          (id) => !camionsActuels.includes(id),
        );

        for (const camionId of aAjouter) {
          await addCamionToTrajet(currentTrajet.id, camionId);
        }
        // for (const camionId of aRetirer) {
        //   await removeCamionFromTrajet(currentTrajet.id, camionId);
        // }
      } else {
        console.log(payload)
        res = await addTrajet(payload);
      }

      if (res && res["status"] === "success") {
        message.success(
          isUpdate
            ? "Trajet mis à jour avec succès"
            : "Trajet ajouté avec succès",
        );
        setTimeout(() => {
          window.location.reload();
        }, 1200);
      } else {
        message.warning(
          res?.message || "Erreur lors de l'enregistrement du trajet",
        );
      }
    } catch (err) {
      console.error(err);
      message.error("Erreur lors de l'enregistrement du trajet");
    } finally {
      setloading(false);
    }
  };

  const resetHistorique = () => {
    sethistoriqueTrajet(historiqueInitial);
    setmodalHistorique(false);
  };

  const handleAddTrajetHistorique = async () => {
    if (!historiqueTrajet.camion_id) {
      message.warning("Veuillez sélectionner le camion concerné");
      return;
    }
    if (!historiqueTrajet.date_arrive) {
      message.warning("La date d'arrivée est obligatoire");
      return;
    }
    if (historiqueTrajet.kilometrage == null) {
      message.warning("Le kilométrage est obligatoire");
      return;
    }

    // setloading(true);
    try {
      const payload = {
        ...historiqueTrajet,
        date_arrive: historiqueTrajet.date_arrive
          ? historiqueTrajet.date_arrive.format("YYYY-MM-DD HH:mm:ss")
          : null,
      };
      console.log(payload)
      const res = await addHistoriqueTrajet(payload);
      if (res.status === "success") {
        message.success("Historique de trajet ajouté avec succès !");
        setTimeout(() => {
          window.location.reload();
        }, 1200);
      } else {
        message.warning(
          res?.message || "Erreur insertion de l'historique du trajet",
        );
      }
    } catch (err) {
      console.error(err);
      message.error("Erreur lors de l'ajout de l'historique");
    } finally {
      setloading(false);
      resetHistorique();
    }
  };

  const handleCancel = () => {
    setIsUpdate(false);
    setshowAddModal(false);
    setcamionsOrigine([]);
    setcurrentTrajet({
      id: null,
      date_depart: null,
      date_arrive: null,
      description: null,
      facture_id: null,
      camion_ids: [],
      pieces_jointes: [],
      kilometrage: 0,
      carburant: 0,
      fond_de_cuve: 0,
      approvisionnement: 0,
    });
  };

  return (
    <div>
      <Row>
        <Col span={3} style={{ textAlign: "center" }}>
          <Button
            type="primary"
            loading={loading}
            style={{ width: "90%" }}
            onClick={handleReload}
          >
            Actualiser
          </Button>
        </Col>
        {parseInt(localStorage.getItem("fonction_id")) === 1 && (
          <Col span={3} style={{ textAlign: "center" }}>
            <Button
              type="default"
              style={{ width: "90%", background: "#096527ff", color: "white" }}
              onClick={() => setshowAddModal(true)}
            >
              + Ajouter
            </Button>
          </Col>
        )}
      </Row>
      <br />
      <Row>
        <Table
          columns={columnsTablePiece}
          dataSource={listeTrajet}
          rowKey="id"
          pagination={{
            pageSize: 9,
            position: ["bottomCenter"],
            className: "custom-pagination",
            style: {
              display: "flex",
              justifyContent: "center",
              marginTop: 12,
            },
            itemRender: (page, type, originalElement) => {
              if (type === "page") {
                return (
                  <div
                    style={{
                      borderRadius: "50%",
                      minWidth: 32,
                      height: 32,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      border: "1px solid #d9d9d9",
                    }}
                  >
                    {page}
                  </div>
                );
              }
              return originalElement;
            },
          }}
          scroll={{ y: 400 }}
          bordered
        />
      </Row>

      <Modal
        open={modalHistorique}
        title={"Réception Trajet"}
        onCancel={resetHistorique}
        onOk={handleAddTrajetHistorique}
        okText={"Enregistrer"}
        cancelText="Annuler"
        width="50%"
        style={{ top: 10 }}
        confirmLoading={loading}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 0,
          }}
        >
          <div>
            <Row gutter={[16, 16]}>
              {!historiqueTrajet.camion_id && (
                <Col xs={24} md={12}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 6,
                    }}
                  >
                    <label style={{ fontWeight: 500 }}>
                      Camion <span style={{ color: "red" }}>*</span>
                    </label>

                    <Select
                      showSearch
                      optionFilterProp="children"
                      style={{ width: "100%" }}
                      placeholder="Sélectionner le camion"
                      value={historiqueTrajet.camion_id}
                      onChange={(value) =>
                        sethistoriqueTrajet({
                          ...historiqueTrajet,
                          camion_id: value,
                        })
                      }
                    >
                      {listeCamion?.map((item) => (
                        <Option key={item.id} value={item.id}>
                          {item.imm}
                        </Option>
                      ))}
                    </Select>
                  </div>
                </Col>
              )}

              <Col xs={24} md={12}>
                <div
                  style={{ display: "flex", flexDirection: "column", gap: 6 }}
                >
                  <label style={{ fontWeight: 500 }}>
                    Date d'arrivée <span style={{ color: "red" }}>*</span>
                  </label>

                  <DatePicker
                    size="small"
                    showTime
                    style={{ width: "100%" }}
                    format="YYYY-MM-DD HH:mm:ss"
                    placeholder="Sélectionner la date et l'heure"
                    value={historiqueTrajet.date_arrive || null}
                    onChange={(date) =>
                      sethistoriqueTrajet({
                        ...historiqueTrajet,
                        date_arrive: date,
                      })
                    }
                  />
                </div>
              </Col>

              <Col xs={24} md={12}>
                <div
                  style={{ display: "flex", flexDirection: "column", gap: 6 }}
                >
                  <label style={{ fontWeight: 500 }}>
                    Kilométrage <span style={{ color: "red" }}>*</span>
                  </label>

                  <InputNumber
                    size="small"
                    min={0}
                    style={{ width: "100%" }}
                    placeholder="Ex : 125000"
                    value={historiqueTrajet.kilometrage}
                    onChange={(value) =>
                      sethistoriqueTrajet({
                        ...historiqueTrajet,
                        kilometrage: value ?? 0,
                      })
                    }
                    addonAfter="km"
                  />
                </div>
              </Col>

              <Col xs={24} md={12}>
                <div
                  style={{ display: "flex", flexDirection: "column", gap: 6 }}
                >
                  <label style={{ fontWeight: 500 }}>Fond de cuve</label>

                  <InputNumber
                    size="small"
                    min={0}
                    style={{ width: "100%" }}
                    placeholder="Fond de cuve"
                    value={historiqueTrajet.fond_de_cuve}
                    onChange={(value) =>
                      sethistoriqueTrajet({
                        ...historiqueTrajet,
                        fond_de_cuve: value ?? 0,
                      })
                    }
                    addonAfter="L"
                  />
                </div>
              </Col>
            </Row>
          </div>

          <div>
            <div
              style={{
                fontSize: 16,
                fontWeight: 600,
                marginTop: 10,
              }}
            >
              Description
            </div>

            <TextArea
              rows={1}
              placeholder="Notes, incidents, remarques..."
              value={historiqueTrajet.description}
              onChange={(e) =>
                sethistoriqueTrajet({
                  ...historiqueTrajet,
                  description: e.target.value,
                })
              }
              style={{
                width: "100%",
                fontSize: 15,
              }}
            />
          </div>

          <div>
            <div
              style={{
                fontSize: 16,
                fontWeight: 600,
                marginBottom: 14,
                marginTop: 14,
              }}
            >
              Pièces jointes
            </div>

            <Upload
              multiple
              beforeUpload={() => false}
              fileList={historiqueTrajet.pieces_jointes || []}
              onChange={({ fileList }) => {
                sethistoriqueTrajet({
                  ...historiqueTrajet,
                  pieces_jointes: fileList,
                });
              }}
            >
              <Button
                size="large"
                icon={<UploadOutlined />}
                style={{
                  width: "100%",
                }}
              >
                Ajouter des fichiers
              </Button>
            </Upload>
          </div>
        </div>
      </Modal>

      <Modal
        open={showAddModal}
        title={isUpdate ? "Modifier le trajet" : "Ajouter un trajet"}
        onCancel={handleCancel}
        footer={null}
        width="50%"
        style={{ top: 10 }}
        confirmLoading={loading}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 0,
          }}
        >
          <div>
            <Row gutter={[16, 16]}>
              <Col xs={24} md={12}>
                <div
                  style={{ display: "flex", flexDirection: "column", gap: 6 }}
                >
                  <label style={{ fontWeight: 500 }}>
                    Camion(s) <span style={{ color: "red" }}>*</span>
                  </label>

                  <Select
                    // mode="multiple"
                    showSearch
                    optionFilterProp="children"
                    size="medium"
                    style={{ width: "100%" }}
                    placeholder="Sélectionner un ou plusieurs camions"
                    value={currentTrajet.camion_ids}
                    onChange={(value) =>
                      setcurrentTrajet({
                        ...currentTrajet,
                        camion_ids: value,
                      })
                    }
                  >
                    {listeCamion?.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.imm}
                      </Option>
                    ))}
                  </Select>
                </div>
              </Col>

              <Col xs={24} md={12}>
                <div
                  style={{ display: "flex", flexDirection: "column", gap: 6 }}
                >
                  <label style={{ fontWeight: 500 }}>
                    Facture <span style={{ color: "red" }}>*</span>
                  </label>

                  <Select
                    showSearch
                    optionFilterProp="children"
                    size="medium"
                    style={{ width: "100%" }}
                    placeholder="Sélectionner une facture"
                    value={currentTrajet.facture_id}
                    onChange={(value) =>
                      setcurrentTrajet({
                        ...currentTrajet,
                        facture_id: value,
                      })
                    }
                  >
                    {listeFactures?.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.ref_facture}
                      </Option>
                    ))}
                  </Select>
                </div>
              </Col>

              <Col xs={24} md={12}>
                <div
                  style={{ display: "flex", flexDirection: "column", gap: 6 }}
                >
                  <label style={{ fontWeight: 500 }}>
                    Date de départ <span style={{ color: "red" }}>*</span>
                  </label>

                  <DatePicker
                    size="small"
                    showTime
                    style={{ width: "100%" }}
                    format="YYYY-MM-DD HH:mm:ss"
                    placeholder="Sélectionner la date et l'heure"
                    value={currentTrajet.date_depart || null}
                    onChange={(date) =>
                      setcurrentTrajet({
                        ...currentTrajet,
                        date_depart: date,
                      })
                    }
                  />
                </div>
              </Col>

              <Col xs={24} md={12}>
                <div
                  style={{ display: "flex", flexDirection: "column", gap: 6 }}
                >
                  <label style={{ fontWeight: 500 }}>
                    Kilométrage <span style={{ color: "red" }}>*</span>
                  </label>

                  <InputNumber
                    size="small"
                    min={0}
                    style={{ width: "100%" }}
                    placeholder="Ex : 125000"
                    value={currentTrajet.kilometrage}
                    onChange={(value) =>
                      setcurrentTrajet({
                        ...currentTrajet,
                        kilometrage: value ?? 0,
                      })
                    }
                    addonAfter="km"
                  />
                </div>
              </Col>
            </Row>
          </div>

          <div>
            <Row gutter={[16, 16]}>
              <Col xs={24} md={12}>
                <div
                  style={{ display: "flex", flexDirection: "column", gap: 6 }}
                >
                  <label style={{ fontWeight: 500 }}>Fond de cuve</label>

                  <InputNumber
                    size="small"
                    min={0}
                    style={{ width: "100%" }}
                    placeholder="Fond de cuve"
                    value={currentTrajet.fond_de_cuve}
                    onChange={(value) =>
                      setcurrentTrajet({
                        ...currentTrajet,
                        fond_de_cuve: value ?? 0,
                      })
                    }
                    addonAfter="L"
                  />
                </div>
              </Col>

              <Col xs={24} md={12}>
                <div
                  style={{ display: "flex", flexDirection: "column", gap: 6 }}
                >
                  <label style={{ fontWeight: 500 }}>Approvisionnement</label>

                  <InputNumber
                    size="small"
                    min={0}
                    style={{ width: "100%" }}
                    placeholder="Quantité approvisionnée"
                    value={currentTrajet.approvisionnement}
                    onChange={(value) =>
                      setcurrentTrajet({
                        ...currentTrajet,
                        approvisionnement: value ?? 0,
                      })
                    }
                    addonAfter="L"
                  />
                </div>
              </Col>
            </Row>
          </div>

          <div>
            <Row gutter={[16, 16]}>
              <Col xs={24} md={12}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 8,
                    marginTop: 15,
                  }}
                >
                  <label style={{ fontWeight: 500 }}>Statut</label>

                  <Radio.Group
                    optionType="button"
                    buttonStyle="solid"
                    value={currentTrajet.statut}
                    onChange={(e) =>
                      setcurrentTrajet({
                        ...currentTrajet,
                        statut: e.target.value,
                      })
                    }
                  >
                    <Radio.Button className="statut-charge" value={true} style={{ width: 200 }}>Chargé</Radio.Button>
                    <Radio.Button className="statut-vide" value={false} style={{ width: 200 }}>Vide</Radio.Button>
                  </Radio.Group>
                </div>
              </Col>
            </Row>
          </div>

          <div>
            <div
              style={{
                fontSize: 16,
                fontWeight: 600,
                marginTop: 10,
              }}
            >
              Description
            </div>

            <TextArea
              rows={1}
              placeholder="Notes, incidents, remarques..."
              value={currentTrajet.description}
              onChange={(e) =>
                setcurrentTrajet({
                  ...currentTrajet,
                  description: e.target.value,
                })
              }
              style={{
                width: "100%",
                fontSize: 15,
              }}
            />
          </div>

          <div>
            <div
              style={{
                fontSize: 16,
                fontWeight: 600,
                marginBottom: 14,
              }}
            >
              Pièces jointes
            </div>

            <Upload
              multiple
              beforeUpload={() => false}
              fileList={currentTrajet.pieces_jointes || []}
              onChange={({ fileList }) => {
                setcurrentTrajet({
                  ...currentTrajet,
                  pieces_jointes: fileList,
                });
              }}
            >
              <Button
                size="large"
                icon={<UploadOutlined />}
                style={{
                  width: "100%",
                }}
              >
                Ajouter des fichiers
              </Button>
            </Upload>

            {isUpdate && (
              <div
                style={{
                  fontSize: 13,
                  color: "#999",
                  marginTop: 8,
                  lineHeight: 1.5,
                }}
              >
                L'ajout de nouvelles pièces jointes en modification n'est pas
                encore pris en charge par l'API — seule la création envoie les
                fichiers.
              </div>
            )}
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 12,
              marginTop: 8,
              paddingTop: 16,
              borderTop: "1px solid #f0f0f0",
            }}
          >
            <Button size="large" onClick={handleCancel}>
              Annuler
            </Button>

            <Button
              type="primary"
              size="large"
              loading={loading}
              onClick={handleAddTrajet}
            >
              {isUpdate ? "Mettre à jour" : "Enregistrer"}
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Trajet;
